export default __webpack_public_path__ + "static/media/opensea-logo.84cbd04e.svg";